import React from 'react';
import { Box, Button } from '@mui/material';
import { addButton, container } from './styles';
import { SearchInfoComponent } from './top-info';
import { PlacesComponent } from './places';
import { useTranslation } from 'src/text';
import { useReports } from './reports-context';

const ReportsContainer: React.FC = () => {
  const { callReportApi, isLoading } = useReports();

  const { reportLabels } = useTranslation();
  return (
    <Box sx={container}>
      <PlacesComponent />
      <SearchInfoComponent />

      <Button disabled={isLoading} onClick={callReportApi} sx={addButton}>
        {reportLabels.generate}
      </Button>
    </Box>
  );
};

export { ReportsContainer };
